import api from '../../api'

const recurrenceAPI = api.create('recurrence')

const get = ({ sellerId = '' }) => {
  return recurrenceAPI.get(`/sellers/${sellerId}`)
}

const update = ({ sellerId = '', ...data }) => {
  return recurrenceAPI.put(`/sellers/${sellerId}`, data)
}

const logo = ({ formData }) => {
  return recurrenceAPI.post(`/seller/logo`, formData)
}

const info = () => {
  return recurrenceAPI.get('/sellers/info')
}

const plans = () => {
  return recurrenceAPI.get('/sellers/plans')
}

export default {
  get,
  update,
  logo,
  info,
  plans,
}
